import apiMeterClient from './apiMeterClient'

const END_POINT = '/readings'

const setOptionsRequest = (options) => {
    let optionString = JSON.stringify(options || '').replace(/"|{|}/g, "").replace(/:/g, '=').replace(/,/g, '&')
    if(optionString.length > 0) optionString = '&' + optionString 
    return optionString
}

const byGateway = (gateway, options) => 
    apiMeterClient.get(`${END_POINT}/gateway/${gateway.id}?key=${gateway.key}${setOptionsRequest(options)}`)

const byMeter = (meter, options) => 
    apiMeterClient.get(`${END_POINT}/meter/${meter.id}?key=${meter.key}${setOptionsRequest(options)}`)

const last = (meters) => apiMeterClient.get(`${END_POINT}/last?meters=${meters.toString()}`)

const daySummary = (meter, time) => 
    apiMeterClient.get(`${END_POINT}/summary/day/${meter}?start=${time.start}&end=${time.end}`)

const hourSummary = (meter, time) => 
    apiMeterClient.get(`${END_POINT}/summary/hour/${meter}?start=${time.start}`)

const Readings = { byGateway, byMeter, last, daySummary, hourSummary }

export default Readings